export function roundDecimal(number: number, decimal: number){
    var decimal = decimal || 2;
    var tmp = Math.pow(10, decimal);
    return Math.round( number*tmp )/tmp;
}